import { useTranslate } from 'react-polyglot';

import { Button } from '@genially/design-system';
import { GeniallyIconIcon } from '@genially/icons';

import { config } from '../../../../bootstrap/application/config/config';
import { ErrorPageContent } from '../../components/ErrorPageContent/ErrorPageContent';
import UnknownErrorImage from './assets/UnknownErrorImage.png';

export const UnknownErrorPage = () => {
  const t = useTranslate();

  const handleButtonClick = () => {
    window.location.href = config.urls.dashboard;
  };

  return (
    <ErrorPageContent
      errorCode={500}
      imageSource={UnknownErrorImage as string}
      title={t('__new.play.internetError500.title')}
      content={t('__new.play.internetError500.text')}
      button={
        <Button
          StartIcon={<GeniallyIconIcon />}
          onClick={handleButtonClick}
          variant={Button.Variant.CTA}
          size={Button.Size.BIG}
        >
          {t('__new.play.finalScreen.autenticatedUser.button')}
        </Button>
      }
    />
  );
};
